(function() {
  'use strict';

  var modal = null;
  var previousFocus = null;

  function openModal() {
    if (!modal) return;
    previousFocus = document.activeElement;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var closeButton = modal.querySelector('.size-chart-close');
    if (closeButton) setTimeout(function() { closeButton.focus(); }, 100);
  }

  function closeModal() {
    if (!modal || modal.hasAttribute('hidden')) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  }

  function init() {
    modal = document.querySelector('[data-sizechart-modal]');
    if (!modal) return;

    modal.querySelectorAll('[data-sizechart-close]').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });

    document.querySelectorAll('[data-sizechart-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
